import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

export class BidStrategyNameColumn extends CampaignuiBaseColumn {
  constructor({ i18n, isCampaign }) {
    const title = i18n.getString('ColumnName_BidStrategyName');
    const property = isCampaign ? 'BidStrategyName' : 'Campaign/BidStrategyName';

    super({
      name: 'BidStrategyName',
      property,
      title,
      sortable: property,
      type: 'string',
      bodyClasses: ['grid-column-BidStrategyName'],
      helpId: 'pop_BA_CampaignGrids_PortfolioBidStrat',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
  }

  template({
    value: BidStrategyName,
  }) {
    // for aggregated rows
    if (BidStrategyName === undefined) {
      return ' ';
    }
    // for data rows
    return BidStrategyName || '-';
  }
}
